
import Vue from 'vue';
import OrangeTick from '../../../Icons/OrangeTick.vue';
/**
- Define checkbox is checked or not with v-model="true/false"
- Checkbox label is given thru slot. Example: < Checkbox > Choice </ Checkbox >
**/
export default Vue.extend<any, any, any, any>({
  name: 'Checkbox',
  data() {
    return {
      selected: false
    };
  },
  components: {
    OrangeTick
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: String,
      default: ''
    },
    /**
     * Checkbox is true if checked
     */
    value: {
      type: Boolean,
      default: false
    },
    /**
     * Customize checkbox icon size
     */
    iconSize: {
      type: String,
      default: '20'
    },
    /**
     * Customize checkbox icon color
     */
    iconColor: {
      type: String,
      default: ''
    },
    /**
     * Set checkbox on error state
     */
    error: {
      type: Boolean,
      default: false
    },
    /**
     * Set checkbox on required and throw false when value is empty
     */
    required: {
      type: Boolean,
      default: false
    },
    /**
     * Set checkbox to disabled view
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Set checkbox without click function
     */
    notclickable: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value() {
      this.selected = this.value;
      if (this.required) {
        this.$emit('inputState', this.selected);
      }
    }
  },
  created() {
    this.selected = this.value;
    if (this.required) {
      /**
       * This method only works if props required is given. Meaning if the checkbox is not checked, inputState = false.
       * @event inputState
       * @type {function}
       */
      this.$emit('inputState', this.selected);
    }
  },
  computed: {
    computedCheckboxSize() {
      return `width: ${this.iconSize}px; height: ${this.iconSize}px;`;
    },
    computedClasses() {
      return {
        show: this.selected,
        disabled: this.disabled,
        error: this.error
      };
    }
  },
  methods: {
    handleClick() {
      if (!this.disabled && !this.notclickable) {
        this.selected = !this.selected;
        /**
         * Method to input checkbox value (true/false)
         * @event input
         * @type {function}
         */
        this.$emit('input', this.selected);
      }
    }
  }
});
